// extracted by mini-css-extract-plugin
module.exports = {"wrapperActionLink":"DistributionComponent_wrapperActionLink__4ggOe","wrapperActionLinkDisabled":"DistributionComponent_wrapperActionLinkDisabled__eiHFP"};